import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { BaseParams } from 'types/utils'

export function useVerifyContractSignature() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function verifyContractSignature({
    id,
    params
  }: BaseParams<{ type: 'flat' | 'offer' }, 'GET'>) {
    if (!id) throw new Error('Contract ID is required')

    const response = await apiClient.get(
      `${SNA_PREFIX}contracts/${id}/validate-signature`,
      {
        params
      }
    )
    return response.data
  }

  return useMutation({
    mutationFn: verifyContractSignature,
    onSuccess: () => {
      toast.success({ message: t('contractRefreshed') })
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
    },
    onError: () => {
      toast.error({ message: t('contractRefreshError') })
    }
  })
}
